"use client";

import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
const PARTNER_DEVICE_IMAGE = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/mac_iphonev4.png";
const partnerAdvantages = ["Partner-approved imagery", "Official course story", "Visitor requirements", "Preferred enquiry route", "Destination context", "Partner-managed updates"];
export default function PartnerCoursePresentation() {
  const scrollToEnquiry = () => {
    document.getElementById("partner-enquiry")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section id="partner-course-presentation" aria-labelledby="partner-course-presentation-heading" className="relative w-full overflow-hidden ![padding:54px_32px_64px_32px] !bg-[rgba(0,0,0,0.06)] !opacity-[0.96] !h-[660px]" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      {/* Premium section background */}
      <div aria-hidden="true" className={["pointer-events-none absolute inset-0", "bg-[radial-gradient(circle_at_30%_68%,rgba(191,255,0,0.12),transparent_29%),radial-gradient(circle_at_72%_30%,rgba(183,154,95,0.15),transparent_28%),linear-gradient(135deg,#FFFDF7_0%,#F7F3E9_60%,#EFE6D5_100%)]"].join(" ")} />

      {/* Subtle top border */}
      <div aria-hidden="true" className={["pointer-events-none absolute inset-x-0 top-0 h-px", "bg-gradient-to-r", "from-transparent via-[#B79A5F]/40 to-transparent"].join(" ")} />

      <div className={["relative z-10 mx-auto grid w-full", "max-w-[1480px]", "grid-cols-1 items-center", "gap-12", "lg:grid-cols-[minmax(0,1.58fr)_minmax(360px,0.82fr)]", "lg:gap-16", "xl:gap-20"].join(" ")}>
        {/* Laptop and iPhone image */}
        <div className={["relative order-2", "flex min-w-0 items-center justify-center", "lg:order-1"].join(" ")}>
          {/* Lime reflected glow */}
          <div aria-hidden="true" className={["pointer-events-none absolute", "bottom-[7%] left-[10%]", "h-[34%] w-[64%]", "rounded-full", "bg-[#BFFF00]/13", "blur-[76px]"].join(" ")} />

          {/* Warm-gold phone glow */}
          <div aria-hidden="true" className={["pointer-events-none absolute", "bottom-[12%] right-[5%]", "h-[48%] w-[28%]", "rounded-full", "bg-[#B79A5F]/15", "blur-[66px]"].join(" ")} />

          <img src={PARTNER_DEVICE_IMAGE} alt="TeeListClub Black Mountain Golf Club profile displayed on a laptop and iPhone" loading="lazy" decoding="async" className="relative block h-auto w-full max-w-[970px] object-contain drop-shadow-[0_30px_34px_rgba(7,63,49,0.17)] !opacity-[1] !text-[rgba(8,36,23,0.6)]" />
        </div>

        {/* Content */}
        <div className="order-1 lg:order-2">
          <p className="font-bold uppercase tracking-[0.19em] text-[#9A793A] !text-xs">
            Premium Course Presentation
          </p>

          <h2 id="partner-course-presentation-heading" className={["mt-4 p-0", "text-[40px] font-medium", "leading-[1.04]", "tracking-[-0.035em]", "text-[#073F31]", "md:text-[50px]", "lg:text-[56px]"].join(" ")} style={{
          fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
        }}>
            Your course,
            <br />
            presented at its best.
          </h2>

          <p className="max-w-[515px] leading-[1.72] text-[#596B63] !text-base ![margin:15px_0px_0px_0px]">
            A professionally curated profile that helps golf travellers
            understand the true quality of your course, its visitor experience
            and the correct route to enquire or book.
          </p>

          <ul className="grid grid-cols-1 gap-3 ![margin:15px_0px_0px_0px] sm:grid-cols-2 lg:grid-cols-1">
            {partnerAdvantages.map(item => <li key={item} className="flex items-center gap-3">
                <span className={["flex size-6 shrink-0", "items-center justify-center", "rounded-full", "border border-[#D8C69B]", "bg-[#FFFDF7]/75", "shadow-[0_3px_10px_rgba(7,63,49,0.05)]"].join(" ")}>
                  <Check className="size-[13px] text-[#073F31]" strokeWidth={1.8} aria-hidden="true" />
                </span>

                <span className="text-[16px] leading-[1.5] text-[#29483E]">
  {item}
            </span>
              </li>)}
          </ul>

          <Button type="button" variant="outline" onClick={scrollToEnquiry} className="h-9 inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border py-2 has-[>svg]:px-3 group mt-8 rounded-[9px] border-[#B79A5F]/70 bg-[#FFFDF7]/58 px-6 text-[11px] font-bold uppercase tracking-[0.07em] text-[#073F31] shadow-[0_7px_20px_rgba(7,63,49,0.06)] backdrop-blur-[6px] transition-all duration-300 !h-[48px] !w-[330px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:-translate-y-[2px] hover:border-[#073F31] hover:bg-[#FFFDF7]">
            Discuss Your Course Presentation

            <ArrowRight className={["ml-2 size-4", "transition-transform duration-200", "group-hover:translate-x-1"].join(" ")} strokeWidth={1.7} aria-hidden="true" />
          </Button>
        </div>
      </div>
    </section>;
}